(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elixir-history-two"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('elixir-history-two')){
 customElements.define('elixir-history-two',class extends HTMLElement{
  connectedCallback(){
   this.abort=new AbortController();this.frame=0;this.rows=[];this.motion=matchMedia('(prefers-reduced-motion: reduce)');
   const signal=this.abort.signal;
   const stop=()=>{this.classList.remove('is-active');cancelAnimationFrame(this.frame);this.frame=0;this.rows=[];this.resize?.disconnect();};
   this.stop=stop;
   if(this.motion.matches||window.Shopify?.designMode||!window.ResizeObserver)return;
   try{
    this.classList.add('is-active');
    const clamp=x=>Math.min(1,Math.max(0,x));
    const update=()=>{
     this.frame=0;if(!this.rows.length)return;
     const y=window.scrollY,vh=window.innerHeight,mobile=window.innerWidth<700;
     this.rows.forEach(({element,stage,top,height})=>{
      if(top>y+vh*1.4||top+height<y-vh*.2)return;
      const hold=element.classList.contains('eh2__scene--hold');
      const p=clamp((y+vh*(hold?.15:.8)-top)/(hold?height-vh*.7:vh*1.35));const ease=p*p*(3-2*p);
      const distance=mobile?75:230;const weak=navigator.connection?.saveData?0.6:1;
      const set=(k,v)=>stage.style.setProperty(k,v);
      set('--main-scale',String(1+(mobile?.10:.30)*(1-ease)*weak));
      set('--main-y',`${(1-ease)*(mobile?22:55)}px`);
      set('--left-x',`${-distance*(1-ease)*weak}px`);set('--right-x',`${distance*(1-ease)*weak}px`);
      set('--side-y',`${(1-ease)*(mobile?55:105)}px`);set('--right-y',`${-(1-ease)*(mobile?35:70)}px`);
      set('--left-angle',`${-4*(1-ease)}deg`);set('--right-angle',`${4*(1-ease)}deg`);
      set('--side-opacity',String(.15+.85*ease));set('--text-y',`${(1-ease)*(mobile?42:75)}px`);
      set('--text-opacity',String(.45+.55*ease));set('--progress',String(p));
     });
    };
    const schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(update);};
    const measure=()=>{this.rows=[...this.querySelectorAll('.eh2__scene')].map(element=>({element,stage:element.querySelector('.eh2__stage'),top:element.getBoundingClientRect().top+window.scrollY,height:element.offsetHeight}));schedule();};
    this.motion.addEventListener('change',()=>{if(this.motion.matches)stop();},{signal});
    window.addEventListener('scroll',schedule,{passive:true,signal});window.addEventListener('resize',measure,{passive:true,signal});
    this.resize=new ResizeObserver(measure);this.resize.observe(this);measure();
   }catch{stop();}
  }
  disconnectedCallback(){this.abort?.abort();this.stop?.();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elixir-history"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('elixir-history')) {
  customElements.define('elixir-history', class extends HTMLElement {
    connectedCallback() {
      this.control = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = [];
      this.rows = [];
      const signal = this.control.signal;
      const videos = [...this.querySelectorAll('.elixir-history__video video')];
      this.historyVideos = videos;
      const visibleVideos = new Map();
      let activeVideo = null;
      const stopVideo = video => { video.muted = true; video.pause(); };
      const playVideo = video => {
        video.muted = false;
        const attempt = video.play();
        attempt?.catch(() => {
          if (activeVideo !== video || document.hidden || this.motion.matches) return;
          video.muted = true;
          video.play()?.catch(() => {});
        });
      };
      const selectVideo = () => {
        const next = this.motion.matches || document.hidden ? null :
          [...visibleVideos].filter(([, ratio]) => ratio >= .2).sort((a,b) => b[1]-a[1])[0]?.[0] || null;
        if (next === activeVideo) return;
        activeVideo = next;
        videos.forEach(video => { if(video !== next) stopVideo(video); });
        if(next) playVideo(next);
      };
      if(window.IntersectionObserver) {
        this.videoObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => visibleVideos.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0));
          selectVideo();
        }, {threshold:[0,.2,.4,.6,.8,1]});
        videos.forEach(video => this.videoObserver.observe(video));
      }
      document.addEventListener('visibilitychange', selectVideo, {signal});
      this.motion.addEventListener('change', selectVideo, {signal});
      const enableAudio = () => { if(activeVideo && !this.motion.matches && !document.hidden) playVideo(activeVideo); };
      document.addEventListener('pointerdown', enableAudio, {signal});
      document.addEventListener('keydown', enableAudio, {signal});
      const finish = () => { this.textObserver?.disconnect(); this.animations.forEach(a => a.cancel()); this.animations = []; this.rows = []; };
      this.motion.addEventListener('change', () => { if(this.motion.matches) finish(); }, {signal});
      if (this.motion.matches || window.Shopify?.designMode || !Element.prototype.animate || !window.ResizeObserver) return;
      try {
        const mobile = matchMedia('(max-width: 699px)').matches;
        const distance = mobile ? 48 : Number(this.dataset.distance) || 140;
        // Text reveals run once as each text enters view, including sticky copies.
        // Content stays visible if observers/animations are unavailable.
        if (window.IntersectionObserver) {
          const pending = new Map();
          this.textObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              const animation = pending.get(entry.target);
              if (animation) animation.play();
              pending.delete(entry.target);
              this.textObserver.unobserve(entry.target);
            });
          }, {rootMargin:'0px 0px -5% 0px',threshold:0});
          this.querySelectorAll('.elixir-history__intro, .elixir-history__copy, .elixir-history__outro').forEach(group => {
            const parts = group.querySelectorAll(':scope > .elixir-history__label, :scope > h1, :scope > h2, .elixir-history__text > *, .elixir-history__lead > *');
            parts.forEach((element, i) => {
              const heading = element.matches('h1,h2');
              const animation = element.animate([
                {opacity:0, transform:`translate3d(0,${heading?(mobile?30:52):(mobile?14:24)}px,0)`,clipPath:heading?'inset(0 0 100% 0)':'inset(0 0 0 0)'},
                {opacity:1, transform:'translate3d(0,0,0)',clipPath:'inset(-5% -2% -5% -2%)'}
              ], {duration:heading?650:500,delay:Math.min(i,2)*(mobile?55:80),fill:'both',easing:'cubic-bezier(.22,.61,.36,1)'});
              animation.pause(); animation.currentTime=0;
              this.animations.push(animation);
              animation.onfinish=()=>animation.cancel();
              pending.set(element,animation);
              this.textObserver.observe(element);
            });
          });
        }
        this.querySelectorAll('.elixir-history__chapter').forEach((row, index) => {
          const copy = row.querySelector('.elixir-history__copy');
          const figures = Array.from(row.querySelectorAll('.elixir-history__figure'));
          const direction = index % 2 === 0 ? 1 : -1;
          const animations = [];
          [...figures.map((figure, i) => [figure, i % 2 ? -direction : direction, figure.classList.contains('elixir-history__extra') ? 65 : 65 + i * 22, mobile ? 1.04 : 1.08, figure.classList.contains('elixir-history__extra') ? 0 : i * (mobile ? .055 : .08)])].forEach(([element, side, y, scale, delay]) => {
            if (!element) return;
            const animation = element.animate([
              {transform:`translate3d(${side*distance}px,${mobile?y*.55:y}px,0) scale(${scale})`,opacity:.25},
              {transform:'translate3d(0,0,0) scale(1)',opacity:1}
            ], {duration:1000,fill:'both',easing:'cubic-bezier(.22,.61,.36,1)'});
            animation.pause(); animation.currentTime = 0;
            animations.push({animation, element, delay, progress:0}); this.animations.push(animation);
          });
          this.rows.push({row,animations,progress:0,done:false});
        });
        const measure = () => {
          this.rows.forEach(item => {
            item.top = item.row.getBoundingClientRect().top + window.scrollY;
            const copy = item.row.querySelector('.elixir-history__copy');
            item.row.classList.toggle('history-can-stick', copy.offsetHeight < window.innerHeight - 180);
            item.animations.forEach(part => {
              const anchor = part.element.closest('.elixir-history__video-slot') || part.element.closest('.elixir-history__extra-slot') || part.element.closest('.elixir-history__gallery');
              part.top = anchor ? anchor.getBoundingClientRect().top + window.scrollY : item.top;
            });
          });
          const chapters=this.querySelector('.elixir-history__chapters');
          this.railTop=chapters.getBoundingClientRect().top+window.scrollY;this.railHeight=chapters.offsetHeight;
          schedule();
        };
        const update = () => {
          this.frame = 0;
          if(this.motion.matches) {this.querySelector('.elixir-history__rail span').style.transform='scaleY(1)'; return;}
          const vh = window.innerHeight, y = window.scrollY;
          this.rows.forEach(item => {
            if(item.done) return;
            item.animations.forEach(part => {
              part.progress=Math.max(part.progress,Math.min(1,Math.max(0,(y+vh*.95-part.top-vh*part.delay)/(vh*.60))));
              part.animation.currentTime=part.progress*1000;
            });
            if(item.animations.every(part=>part.progress===1)){item.done=true;item.animations.forEach(part=>part.animation.cancel());}
          });
          const rail=this.querySelector('.elixir-history__rail span');
          if(rail)rail.style.transform=`scaleY(${Math.min(1,Math.max(0,(y+vh*.6-this.railTop)/this.railHeight))})`;
        };
        const schedule = () => {if(!this.frame)this.frame=requestAnimationFrame(update);};
        this.addEventListener('focusin', finish, {signal});
        window.addEventListener('scroll', schedule, {passive:true,signal});
        window.addEventListener('resize', measure, {passive:true,signal});
        this.resize=new ResizeObserver(measure);this.resize.observe(this);
        measure();
      } catch {finish();}
    }
    disconnectedCallback(){this.textObserver?.disconnect();this.videoObserver?.disconnect();this.historyVideos?.forEach(video=>{video.muted=true;video.pause();});this.control?.abort();this.resize?.disconnect();cancelAnimationFrame(this.frame);this.animations?.forEach(a=>a.cancel());}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elixir-loyalty"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('elixir-loyalty')){
customElements.define('elixir-loyalty',class extends HTMLElement{
 connectedCallback(){
  this.controller=new AbortController();const signal=this.controller.signal;
  this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.animations=[];
  const card=this.querySelector('[data-card]'),flip=this.querySelector('[data-flip]');
  flip.addEventListener('click',()=>{
   const flipped=card.classList.toggle('is-flipped');flip.setAttribute('aria-pressed',String(flipped));
   card.children[0].setAttribute('aria-hidden',String(flipped));card.children[1].setAttribute('aria-hidden',String(!flipped));
  },{signal});
  const object=this.querySelector('.elx-loyalty__perspective'),tilt=this.querySelector('.elx-loyalty__tilt');
  let bounds=null;
  object.addEventListener('pointerenter',()=>{bounds=object.getBoundingClientRect();},{signal});
  object.addEventListener('pointermove',e=>{
   if(this.motion.matches||e.pointerType!=='mouse'||!bounds)return;
   tilt.style.setProperty('--ry',((e.clientX-bounds.left)/bounds.width-.5)*12+'deg');
   tilt.style.setProperty('--rx',-((e.clientY-bounds.top)/bounds.height-.5)*8+'deg');
  },{passive:true,signal});
  object.addEventListener('pointerleave',()=>{bounds=null;tilt.style.removeProperty('--rx');tilt.style.removeProperty('--ry');},{signal});
  const finish=()=>{this.observer?.disconnect();this.animations.forEach(a=>a.cancel());};
  this.motion.addEventListener('change',()=>{if(this.motion.matches)finish();},{signal});
  this.addEventListener('focusin',e=>{this.animations.forEach(a=>{if(a.effect?.target?.contains(e.target))a.cancel();});},{signal});
  if(this.motion.matches||window.Shopify?.designMode||!window.IntersectionObserver||!Element.prototype.animate)return;
  try{
   const mobile=matchMedia('(max-width:749px)').matches;const pending=new Map();
   this.observer=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{if(entry.isIntersecting){pending.get(entry.target)?.play();pending.delete(entry.target);this.observer.unobserve(entry.target);}});
   },{rootMargin:'0px 0px -7% 0px',threshold:0});
   this.querySelectorAll('[data-lr], [data-token]').forEach((el,i)=>{
    const token=el.hasAttribute('data-token'),side=i%2?-1:1,end=getComputedStyle(el).transform;
    const from=token?{transform:`translate(${side*(mobile?170:420)}px,100px) rotate(${side*25}deg)`,opacity:0}:{transform:`translate3d(${el.matches('article')?side*(mobile?30:65):0}px,${mobile?28:48}px,0)`,opacity:0};
    const a=el.animate([from,{transform:end==='none'?'translate3d(0,0,0)':end,opacity:1}],{duration:token?850:650,delay:token?(Number(el.style.getPropertyValue('--i'))+2)*60:0,fill:'both',easing:'cubic-bezier(.22,.61,.36,1)'});
    a.pause();a.currentTime=0;a.onfinish=()=>a.cancel();this.animations.push(a);pending.set(el,a);this.observer.observe(el);
   });
  }catch{finish();}
 }
 disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.animations?.forEach(a=>a.cancel());}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elixir-outfit"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('elixir-outfit')) {
  class ElixirOutfit extends HTMLElement {
    connectedCallback() {
      if (this.active) return;
      this.active = true;
      this.mountVersion = (this.mountVersion || 0) + 1;
      this.controller = new AbortController();
      this.words = JSON.parse(this.querySelector('[data-words]').textContent);
      this.threeWords = JSON.parse(this.querySelector('[data-outfit3d-words]')?.textContent || '{}');
      this.threeContainer = this.querySelector('[data-outfit3d]'); this.displayMode = 'photo'; this.threeAuto = false;
      this.pieces = new Map([...this.querySelectorAll('[data-piece]')].map(n => { const p = JSON.parse(n.textContent); return [p.id, p]; }));
      const manifest = JSON.parse(this.querySelector('[data-visual-manifest]')?.textContent || '{}');
      this.pieces.forEach(p => { p.visual = manifest[p.handle] || { views: ['front'], rotation: false }; });
      this.querySelectorAll('[data-filter]').forEach(button => { const count = [...this.querySelectorAll('[data-card]')].filter(card => (card.dataset.filterCategory || card.dataset.category) === button.dataset.filter).length; const label = button.querySelector('[data-filter-count]'); if (label) label.textContent = String(count); });
      this.dragImages = new Map(); this.returningGhosts = new Set();
      this.selected = {}; this.versions = {}; this.pending = new Set(); this.cache = new Map(); this.locked = false; this.drag = null; this.restoreRun = 0;
      this.format = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency });
      this.stage = this.querySelector('[data-stage]'); this.person = this.querySelector('[data-person]'); this.status = this.querySelector('[data-status]');
      this.summary = this.querySelector('[data-summary]'); this.dialog = this.querySelector('dialog');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.storageKey = 'elixir-outfit:v3';
      this.detail = this.querySelector('[data-detail]');
      this.scene = this.querySelector('[data-scene]');
      this.wardrobe = this.querySelector('[data-wardrobe]'); this.wardrobe.append(this.detail);
      this.pieces.forEach(p => { if (p.detailImage) p.photos.unshift({src:p.detailImage,thumb:p.detailImage,alt:p.title}); });
      this.querySelectorAll('.eo3-card-name').forEach(n => n.textContent = this.shortTitle(n.textContent));
      this.querySelectorAll('[data-layer]').forEach(n => n.replaceChildren());
      const on = (target, type, fn, opts = {}) => target.addEventListener(type, fn, { ...opts, signal: this.controller.signal });
      on(this, 'click', e => this.onClick(e));
      if (this.threeContainer) on(this.threeContainer, 'outfit3d:error', () => { if (!this.active) return; this.viewer3d?.dispose(); this.viewer3d = null; this.threeMountPromise = null; this.setDisplayMode('photo'); this.say(this.threeWords.error, true); });
      on(this, 'change', e => { if (e.target.matches('[data-variant-select]')) this.setVariant(e.target.dataset.variantSelect, e.target.value); });
      on(this, 'pointerdown', e => this.pointerDown(e));
      on(this, 'pointerover', e => { const b = e.target.closest('[data-pick]'); if (b && e.pointerType !== 'touch') this.preloadPiece(this.pieces.get(b.dataset.pick)); });
      on(this, 'focusin', e => { const b = e.target.closest('[data-pick]'); if (b) this.preloadPiece(this.pieces.get(b.dataset.pick)); });
      on(window, 'pointermove', e => this.pointerMove(e), { passive: false });
      on(window, 'pointerup', e => this.pointerUp(e));
      on(window, 'pointercancel', () => this.cancelDrag(false));
      on(this, 'lostpointercapture', () => { if (this.drag?.started) this.cancelDrag(false); });
      on(window, 'blur', () => this.cancelDrag(false));
      on(document, 'visibilitychange', () => { if (document.hidden) this.cancelDrag(false); });
      on(this, 'dragstart', e => e.preventDefault());
      on(document, 'keydown', e => { if (e.key === 'Escape' && !this.dialog.open) { this.clearReturningGhosts(); if (this.drag) this.cancelDrag(false); else if (!this.detail.hidden) this.closeDetail(); else this.setZoom('full'); } });
      on(this.dialog, 'click', e => { if (e.target === this.dialog) this.dialog.close(); });
      on(this.dialog, 'close', () => this.galleryTrigger?.focus({ preventScroll: true }));
      this.render(); this.filter(this.querySelector('[data-filter]')?.dataset.filter);
      this.pieces.forEach(p => { const price = this.querySelector('[data-card="' + p.id + '"] [data-catalog-price]'); if (price) { const min = Math.min(...p.variants.map(v => v.price)); price.textContent = (p.variants.some(v => v.price !== min) ? this.words.from + ' ' : '') + this.money(min); } });
      this.resizeObserver = new ResizeObserver(() => this.frameModel());
      this.resizeObserver.observe(this.scene || this.stage);
      this.checkSaved();
      this.setAttribute('data-state', 'idle');
      this.setDisplayMode('3d');
    }
    disconnectedCallback() {
      this.cancelDrag(false); this.clearReturningGhosts(); this.controller?.abort(); this.resizeObserver?.disconnect(); clearTimeout(this.toastTimer); this.dialog?.close(); this.cache?.clear(); this.dragImages?.clear();
      this.viewer3d?.dispose(); this.viewer3d = null; this.threeMountPromise = null;
      this.active = false; this.restoreRun++; for (const cat of ['top', 'bottom', 'accessory']) this.versions[cat] = (this.versions[cat] || 0) + 1;
    }
    shortTitle(title) { return title.replace(/^Elixir\s+/i, ''); }
    node(tag, cls, text) { const n = document.createElement(tag); if (cls) n.className = cls; if (text !== undefined) n.textContent = text; return n; }
    button(cls, text) { const n = this.node('button', cls, text); n.type = 'button'; return n; }
    money(value) {
      const pattern = this.dataset.moneyFormat;
      if (!pattern || this.dataset.shopCurrency !== this.dataset.currency) return this.format.format(value / 100);
      const token = pattern.match(/\{\{\s*(amount(?:_\w+)?)\s*\}\}/);
      if (!token) return this.format.format(value / 100);
      const name = token[1], decimals = name.includes('no_decimals') ? 0 : 2;
      const decimal = name.includes('comma_separator') || name.includes('space_separator') ? ',' : '.';
      const separator = name.includes('space_separator') ? '\u202f' : name.includes('apostrophe_separator') ? "'" : name.includes('comma_separator') ? '.' : ',';
      const parts = (value / 100).toFixed(decimals).split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);
      const decoder = document.createElement('span'); decoder.innerHTML = pattern.replace(token[0], parts.join(decimal)); return decoder.textContent;
    }
    say(text, error = false) { this.status.textContent = text; this.status.classList.toggle('is-error', error); }
    toast(text) { const n = this.querySelector('[data-toast]'); clearTimeout(this.toastTimer); n.textContent = text; n.hidden = false; this.toastTimer = setTimeout(() => { n.hidden = true; }, 2200); }
    onClick(e) {
      const modeButton = e.target.closest('button[data-display-mode]'); if (modeButton) this.setDisplayMode(modeButton.dataset.displayMode);
      const viewButton = e.target.closest('[data-three-view]'); if (viewButton) { this.threeAuto = false; this.viewer3d?.setAutoRotate(false); this.updateThreeAuto(); this.viewer3d?.setView(viewButton.dataset.threeView); }
      if (e.target.closest('[data-three-auto]')) { this.threeAuto = Boolean(this.viewer3d?.setAutoRotate(!this.threeAuto)); this.updateThreeAuto(); }
      if (e.target.closest('[data-three-reset]')) { this.threeAuto = false; this.viewer3d?.setAutoRotate(false); this.updateThreeAuto(); this.viewer3d?.reset(); }
      const pick = e.target.closest('[data-pick]');
      if (pick) { if (performance.now() < (this.suppressClickUntil || 0)) { e.preventDefault(); return; } this.equip(pick.dataset.pick); }
      const filter = e.target.closest('[data-filter]'); if (filter) this.filter(filter.dataset.filter);
      const remove = e.target.closest('[data-remove]'); if (remove) this.removePiece(remove.dataset.remove);
      const variant = e.target.closest('[data-variant]'); if (variant) this.setVariant(variant.dataset.category, variant.dataset.variant);
      const inspect = e.target.closest('[data-inspect]'); if (inspect) this.openDetail(inspect.dataset.inspect, inspect);
      const photo = e.target.closest('[data-photo]'); if (photo) this.showPhoto(Number(photo.dataset.photo));
      const zoom = e.target.closest('button[data-zoom]'); if (zoom) this.setZoom(zoom.dataset.zoom);
      if (e.target.closest('[data-close-detail]')) this.closeDetail();
      if (e.target.closest('[data-detail-prev]')) this.detailPhoto(-1);
      if (e.target.closest('[data-detail-next]')) this.detailPhoto(1);
      if (e.target.closest('[data-all-photos]') && this.detailPiece) this.inspect(this.detailPiece.id, e.target.closest('button'));
      if (e.target.closest('[data-reset]')) this.reset();
      if (e.target.closest('[data-view-reset]')) { this.cancelDrag(false); this.setZoom('full'); }
      if (e.target.closest('[data-add]')) this.addToCart();
      if (e.target.closest('[data-save]')) this.save();
      if (e.target.closest('[data-restore]')) this.restore();
      if (e.target.closest('[data-restore-previous]')) this.restore(this.storageKey + ':previous');
      if (e.target.closest('[data-close-gallery]')) this.dialog.close();
      if (e.target.closest('[data-toggle-summary]')) this.toggleSummary();
      const empty = e.target.closest('[data-browse]'); if (empty) { this.filter(empty.dataset.browse); this.querySelector('[data-wardrobe]').scrollIntoView({ behavior: this.reduced ? 'instant' : 'smooth', block: 'nearest' }); this.querySelector('[data-card]:not([hidden]) [data-pick]')?.focus({ preventScroll: true }); }
    }
    filter(category) {
      if (!category) return; this.cancelDrag();
      this.querySelectorAll('[data-filter]').forEach(n => n.setAttribute('aria-pressed', String(n.dataset.filter === category)));
      this.querySelectorAll('[data-card]').forEach(n => n.hidden = (n.dataset.filterCategory || n.dataset.category) !== category);
      const rack = this.querySelector('[data-rack]'); rack.scrollTop = 0; rack.scrollLeft = 0;
    }
    async imageFor(piece) {
      if (!piece.render) return null;
      if (this.cache.has(piece.id)) return this.cache.get(piece.id);
      const promise = new Promise((resolve, reject) => {
        const img = new Image(); const timer = setTimeout(() => reject(new Error('timeout')), 18000);
        img.onload = async () => { clearTimeout(timer); try { await img.decode(); } catch (_) {} resolve(img); }; img.onerror = () => { clearTimeout(timer); reject(new Error('image')); };
        img.src = piece.render; img.alt = piece.title; img.width = 1024; img.height = 1536;
      });
      this.cache.set(piece.id, promise); promise.catch(() => { if (this.cache.get(piece.id) === promise) this.cache.delete(piece.id); }); return promise;
    }
    preloadPiece(piece) {
      if (piece?.render) this.imageFor(piece).catch(() => {});
      if (piece?.visual?.drag) this.dragImageFor(piece).catch(() => {});
    }
    async equip(id, variantId = null, restoreRun = null) {
      if (this.locked) return false; this.cancelDrag(false);
      if (restoreRun === null) this.restoreRun++; else if (restoreRun !== this.restoreRun) return false;
      const piece = this.pieces.get(id); if (!piece) return false;
      const cat = piece.category, token = (this.versions[cat] || 0) + 1; this.versions[cat] = token;
      const mount = this.mountVersion;
      this.pending.add(cat); this.setAttribute('data-state', 'loading'); this.say(this.words.loading); this.updateTotal();
      try {
        const image = await this.imageFor(piece);
        if (this.mountVersion !== mount || this.versions[cat] !== token || !this.active || (restoreRun !== null && restoreRun !== this.restoreRun)) return false;
        this.commit(piece, image, variantId); return true;
      } catch (_) { if (this.mountVersion === mount && this.versions[cat] === token) { this.say(this.words.image_error + ' ' + piece.title, true); this.setAttribute('data-state', 'error'); } return false; }
      finally { if (this.mountVersion === mount) { if (this.versions[cat] === token) this.pending.delete(cat); this.updateTotal(); } }
    }
    commit(piece, image, variantId = null) {
      const cat = piece.category, previous = this.selected[cat];
      const variant = piece.variants.find(v => String(v.id) === String(variantId) && v.available) || (previous?.piece.id === piece.id ? piece.variants.find(v => v.id === previous.variant?.id && v.available) : null) || (piece.variants.length === 1 && piece.variants[0].available ? piece.variants[0] : null);
      this.selected[cat] = { piece, variant }; this.paint(cat, image); this.setAttribute('data-state', 'equipped');
      if (this.detailPiece?.category === cat && this.detailPiece.id !== piece.id) this.closeDetail(false);
      this.lastAdded = ''; this.uncertain = false; this.querySelector('[data-cart]').hidden = true;
      this.querySelector('[data-hint]').classList.add('is-used'); this.render(); this.say((image ? this.words.equipped : this.threeWords.selected) + ': ' + piece.title); this.toast(image ? this.words.equipped : this.threeWords.selected);
      if (!image && piece.photos?.length) this.openDetail(piece.id, this.querySelector('[data-pick="' + piece.id + '"]'));
      this.stage.classList.remove('is-confirmed'); requestAnimationFrame(() => { if (this.active) this.stage.classList.add('is-confirmed'); });
    }
    paint(cat, image) { const layer = this.querySelector('[data-layer="' + cat + '"]'); layer.replaceChildren(); if (!image) return; const copy = image.cloneNode(); copy.className = 'eo3-worn'; layer.append(copy); }
    removePiece(cat) {
      if (this.locked) return; this.cancelDrag(); this.restoreRun++; this.versions[cat] = (this.versions[cat] || 0) + 1; this.pending.delete(cat);
      if (this.detailPiece?.category === cat) this.closeDetail(false);
      delete this.selected[cat]; this.querySelector('[data-layer="' + cat + '"]').replaceChildren(); this.lastAdded = ''; this.uncertain = false; this.render(); this.say(this.words.removed);
    }
    reset() { if (this.locked) return; ['top', 'bottom', 'accessory'].forEach(cat => this.removePiece(cat)); this.setZoom('full'); this.querySelector('[data-cart]').hidden = true; this.setAttribute('data-state', 'idle'); this.say(this.words.reset_done); }
    pointerDown(e) {
      if (this.displayMode === '3d') return;
      const button = e.target.closest('[data-pick]');
      if (!button || this.locked || e.button !== 0 || e.pointerType === 'touch') return;
      this.clearReturningGhosts(); this.cancelDrag(false); const piece = this.pieces.get(button.dataset.pick); if (!piece?.render) return;
      // Unknown images remain available by click, but are never passed off as isolated garments.
      if (!piece.visual?.drag) return;
      this.dragImageFor(piece).catch(() => {});
      this.drag = { pointer: e.pointerId, piece, button, startX: e.clientX, startY: e.clientY, x: e.clientX, y: e.clientY, started: false, valid: false, image: null };
    }
    startDrag(d) {
      d.started = true; this.restoreRun++; this.closeDetail(false); this.versions[d.piece.category] = (this.versions[d.piece.category] || 0) + 1; this.pending.delete(d.piece.category);
      try { d.button.setPointerCapture(d.pointer); } catch (_) {}
      d.origin = d.button.getBoundingClientRect(); d.button.classList.add('is-dragging');
      d.ghost = this.node('div', 'eo3-ghost is-awaiting'); d.ghost.setAttribute('aria-hidden', 'true');
      const visual = d.piece.visual.drag, ns = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(ns, 'svg'), img = document.createElementNS(ns, 'image');
      svg.setAttribute('viewBox', visual.bounds.join(' ')); svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      img.setAttribute('width', visual.width); img.setAttribute('height', visual.height); img.setAttribute('href', visual.url); svg.append(img); d.ghost.append(svg);
      d.ratio = visual.bounds[2] / visual.bounds[3];
      // Hold near the shoulder/waist; keep the bottom away from the cursor.
      d.grip = { x: Math.max(.22, Math.min(.78, (d.startX - d.origin.left) / d.origin.width)), y: d.piece.category === 'accessory' ? .45 : .18 };
      document.body.append(d.ghost);
      this.stage.dataset.dragCategory = d.piece.category; this.setAttribute('data-state', 'dragging'); this.say(this.words.dragging);
      this.dragImageFor(d.piece).then(() => { if (this.drag === d) { d.ghost.classList.remove('is-awaiting'); this.moveDrag(d); } }).catch(() => { if (this.drag === d) { this.cancelDrag(false); this.say(this.words.image_error + ' ' + d.piece.title, true); } });
      this.imageFor(d.piece).then(image => { if (this.drag !== d) return; d.image = image; this.moveDrag(d); }).catch(() => { if (this.drag === d) { this.cancelDrag(); this.say(this.words.image_error + ' ' + d.piece.title, true); } });
    }
    dragImageFor(piece) {
      if (this.dragImages.has(piece.id)) return this.dragImages.get(piece.id);
      const promise = new Promise((resolve, reject) => {
        const img = new Image(), timer = setTimeout(() => reject(new Error('timeout')), 18000);
        img.onload = async () => { clearTimeout(timer); try { await img.decode(); } catch (_) {} resolve(img); };
        img.onerror = () => { clearTimeout(timer); reject(new Error('image')); }; img.src = piece.visual.drag.url;
      });
      this.dragImages.set(piece.id, promise);
      promise.catch(() => { if (this.dragImages.get(piece.id) === promise) this.dragImages.delete(piece.id); });
      return promise;
    }
    pointerMove(e) {
      const d = this.drag; if (!d || d.pointer !== e.pointerId) return;
      d.x = e.clientX; d.y = e.clientY;
      if (!d.started && Math.hypot(d.x - d.startX, d.y - d.startY) > 7) this.startDrag(d);
      if (!d.started) return; e.preventDefault(); this.moveDrag(d);
    }
    inZone(d) {
      const r = this.person.getBoundingClientRect(), zone = { top: [.23, .14, .78, .53], bottom: [.24, .49, .77, .97], accessory: [.38, .01, .62, .16] }[d.piece.category];
      const pad = d.valid ? 18 : 0;
      return d.x >= r.left + r.width * zone[0] - pad && d.x <= r.left + r.width * zone[2] + pad && d.y >= r.top + r.height * zone[1] - pad && d.y <= r.top + r.height * zone[3] + pad;
    }
    moveDrag(d) {
      const r = this.person.getBoundingClientRect(), frame = this.scene.getBoundingClientRect();
      const proximity = Math.max(0, 1 - Math.abs(d.x - (r.left + r.width / 2)) / Math.max(1, frame.width));
      const limit = d.piece.category === 'accessory' ? 180 : d.piece.category === 'bottom' ? 430 : 440;
      const height = Math.max(100, Math.min(limit, frame.height * .64, window.innerHeight * .65));
      const width = Math.min(height * d.ratio, frame.width * .80);
      const scale = 1 + proximity * .06, h = width / d.ratio * scale, w = width * scale;
      d.ghost.style.width = w + 'px'; d.ghost.style.height = h + 'px';
      // Position follows the pointer directly; no easing is applied to motion.
      d.ghost.style.transform = 'translate3d(' + (d.x - w * d.grip.x) + 'px,' + (d.y - h * d.grip.y) + 'px,0)';
      const valid = this.inZone(d);
      if (valid !== d.valid || (valid && d.image && !d.previewed)) {
        d.valid = valid; this.stage.classList.toggle('is-valid', valid);
        if (valid && d.image) this.preview(d); else this.unpreview(d);
      }
      const hint = this.querySelector('[data-drop-label]'); hint.textContent = valid ? (d.image ? this.words.release : this.words.loading) : this.words['target_' + d.piece.category];
    }
    preview(d) {
      d.previewed = true;
      const reveal = () => {
        if (this.drag !== d || !d.valid) return;
        const host = this.querySelector('[data-preview-layer]'); host.className = 'eo3-layer eo3-' + d.piece.category;
        const img = d.image.cloneNode(); img.className = 'eo3-worn'; host.replaceChildren(img); host.hidden = false;
        this.querySelector('[data-layer="' + d.piece.category + '"]').style.visibility = 'hidden';
        d.ghost.classList.add('is-snapped'); this.setAttribute('data-state', 'preview');
        const note = this.querySelector('[data-preview-note]'); note.textContent = this.words.preview + ' · ' + d.piece.title; note.hidden = false;
      };
      reveal();
    }
    unpreview(d) {
      this.querySelector('[data-preview-layer]').hidden = true; this.querySelector('[data-preview-layer]').replaceChildren();
      if (d) { clearTimeout(d.previewTimer); d.snapAnimation?.cancel(); d.snapAnimation = null; this.querySelector('[data-layer="' + d.piece.category + '"]').style.visibility = ''; d.previewed = false; d.ghost?.classList.remove('is-snapped'); }
      this.querySelector('[data-preview-note]').hidden = true;
      if (d?.started) this.setAttribute('data-state', 'dragging');
    }
    pointerUp(e) {
      const d = this.drag; if (!d || d.pointer !== e.pointerId) return;
      if (!d.started) { this.drag = null; return; }
      d.x = e.clientX; d.y = e.clientY; this.suppressClickUntil = performance.now() + 500;
      const valid = this.inZone(d); const image = d.image; this.finishDrag(d, !valid);
      if (valid && image) this.commit(d.piece, image); else if (valid) this.equip(d.piece.id); else this.say(this.words.cancelled);
    }
    finishDrag(d, returnHome) {
      this.unpreview(d); this.drag = null; delete this.stage.dataset.dragCategory; this.stage.classList.remove('is-valid'); d.button.classList.remove('is-dragging');
      try { if (d.button.hasPointerCapture(d.pointer)) d.button.releasePointerCapture(d.pointer); } catch (_) {}
      if (d.ghost) {
        if (returnHome && !this.reduced && d.origin) {
          const rect = d.ghost.getBoundingClientRect(); const a = d.ghost.animate([{ opacity: 1, transform: d.ghost.style.transform }, { opacity: 0, transform: 'translate(' + (d.origin.left + d.origin.width / 2 - rect.width / 2) + 'px,' + d.origin.top + 'px) scale(.5)' }], { duration: 160, easing: 'cubic-bezier(.2,.7,.2,1)' });
          const entry = { element: d.ghost, animation: a }; this.returningGhosts.add(entry);
          a.finished.catch(() => {}).finally(() => { entry.element.remove(); this.returningGhosts.delete(entry); });
        } else d.ghost.remove();
      }
      this.setAttribute('data-state', Object.keys(this.selected).length ? 'equipped' : 'idle'); this.updateTotal();
    }
    clearReturningGhosts() { this.returningGhosts?.forEach(entry => { entry.animation.cancel(); entry.element.remove(); }); this.returningGhosts?.clear(); }
    cancelDrag(animate = true) { if (!animate) this.clearReturningGhosts(); const d = this.drag; if (!d) return; if (d.started) { this.suppressClickUntil = performance.now() + 500; this.finishDrag(d, animate); this.say(this.words.cancelled); } else this.drag = null; }
    setVariant(cat, id) {
      if (this.locked) return; const row = this.selected[cat]; if (!row) return;
      row.variant = row.piece.variants.find(v => String(v.id) === String(id) && v.available) || null;
      this.lastAdded = ''; this.uncertain = false; this.say(''); this.renderSlot(cat); this.querySelector('[data-slot="' + cat + '"]').classList.remove('needs-choice'); this.updateTotal();
      this.querySelector('[data-variant="' + id + '"]')?.focus({ preventScroll: true });
    }
    render() { ['top', 'bottom', 'accessory'].forEach(cat => this.renderSlot(cat)); this.querySelectorAll('[data-pick]').forEach(b => { const p = this.pieces.get(b.dataset.pick); b.setAttribute('aria-pressed', String(this.selected[p.category]?.piece.id === p.id)); }); this.updateTotal(); this.syncThreeSelection(); }
    renderSlot(cat) {
      const slot = this.querySelector('[data-slot="' + cat + '"]'); slot.replaceChildren(); const row = this.selected[cat];
      slot.append(this.node('p', 'eo3-slot-label', this.words[cat]));
      if (!row) { const empty = this.button('eo3-empty', '+'); empty.dataset.browse = cat; empty.append(this.node('span', '', this.words['empty_' + cat])); slot.append(empty); return; }
      const p = row.piece;
      if (!p.render) slot.append(this.node('p', 'eo3-slot-visual-note', p.handle === 'elixir-spider-red-leather-jacket' ? this.threeWords.three_red : this.threeWords.missing));
      const details = this.node('div', 'eo3-item'); const inspect = this.button('eo3-inspect'); inspect.dataset.inspect = p.id; inspect.setAttribute('aria-label', this.words.details + ': ' + p.title);
      const img = this.node('img'); img.src = p.image; img.alt = ''; img.width = 80; img.height = 96; inspect.append(img);
      const text = this.node('div', 'eo3-item-text'); const name = this.node('a', 'eo3-item-name', this.shortTitle(p.title)); name.href = p.url;
      const min = Math.min(...p.variants.map(v => v.price)); const varies = p.variants.some(v => v.price !== min);
      text.append(name, this.node('span', 'eo3-item-price', (row.variant ? '' : varies ? this.words.from + ' ' : '') + this.money(row.variant?.price ?? min)));
      const detail = this.button('eo3-detail-link', this.words.details); detail.dataset.inspect = p.id; text.append(detail);
      const remove = this.button('eo3-remove', '×'); remove.dataset.remove = cat; remove.setAttribute('aria-label', this.words.remove + ': ' + p.title); remove.disabled = this.locked;
      details.append(inspect, text, remove); slot.append(details);
      const fieldset = this.node('fieldset', 'eo3-sizes'); fieldset.dataset.variantGroup = cat; fieldset.disabled = this.locked;
      const option = p.options[0] || ''; fieldset.append(this.node('legend', '', p.options.length === 1 ? /^(talla|size)$/i.test(option) ? this.words.size_label : option : this.words.variant));
      if (p.variants.length === 1 && row.variant && p.options.length <= 1) { fieldset.querySelector('legend').append(this.node('span', 'eo3-choice-state', ' · ' + this.words.selected_label)); fieldset.append(this.node('span', 'eo3-single-variant', row.variant.title === 'Default Title' ? this.words.one_size : row.variant.title)); slot.append(fieldset); return; }
      if (p.options.length === 1 && p.variants.length <= 12) {
        p.variants.forEach(v => { const b = this.button('eo3-size', v.title === 'Default Title' ? this.words.one_size : v.title); b.dataset.variant = v.id; b.dataset.category = cat; b.disabled = !v.available; b.setAttribute('aria-pressed', String(row.variant?.id === v.id)); b.setAttribute('aria-label', (v.title === 'Default Title' ? this.words.one_size : v.title) + (v.available ? '' : ' · ' + this.words.sold_out)); b.title = v.available ? v.title : this.words.sold_out; fieldset.append(b); });
      } else {
        const select = this.node('select'); select.dataset.variantSelect = cat; select.setAttribute('aria-label', this.words.variant + ': ' + p.title);
        const placeholder = this.node('option', '', this.words.choose); placeholder.value = ''; placeholder.disabled = true; placeholder.selected = !row.variant; select.append(placeholder);
        p.variants.forEach(v => { const op = this.node('option', '', v.title + (v.available ? '' : ' · ' + this.words.sold_out)); op.value = v.id; op.disabled = !v.available; op.selected = row.variant?.id === v.id; select.append(op); }); fieldset.append(select);
      }
      slot.append(fieldset);
      if (row.variant) { const chosen = this.node('span', 'eo3-choice-state', ' · ' + this.words.selected_label); fieldset.querySelector('legend').append(chosen); }
      else { const message = this.node('p', 'eo3-choice-note', p.variants.some(v => v.available) ? this.words.size_pending : this.words.sold_out); message.id = this.id + '-pending-' + cat; fieldset.setAttribute('aria-describedby', message.id); slot.append(message); }
      if (!p.variants.some(v => v.available)) slot.append(this.node('p', 'eo3-stock-note', this.words.sold_out));
    }
    signature() { return Object.values(this.selected).map(s => s.piece.id + ':' + (s.variant?.id || '')).sort().join('|'); }
    updateTotal() {
      const rows = Object.values(this.selected); const missing = rows.filter(s => !s.variant?.available).length;
      this.querySelector('[data-pending]').textContent = missing ? this.words.pending_label.replace('[count]', missing) : '';
      const total = rows.reduce((n, s) => n + (s.variant?.price ?? Math.min(...s.piece.variants.map(v => v.price))), 0);
      this.querySelectorAll('[data-total]').forEach(n => n.textContent = this.money(total)); this.querySelectorAll('[data-count]').forEach(n => n.textContent = String(rows.length));
      this.querySelectorAll('[data-add]').forEach(b => { b.disabled = this.locked || this.pending.size > 0 || this.restoringRun === this.restoreRun || !rows.length || this.lastAdded === this.signature() || this.uncertain; b.textContent = this.locked ? this.words.adding : this.lastAdded && this.lastAdded === this.signature() ? this.words.added_short : missing ? this.words.choose_pending.replace('[count]', missing) : this.words.add; });
      this.querySelector('[data-save]')?.toggleAttribute('disabled', !rows.length || this.locked || this.pending.size > 0 || this.restoringRun === this.restoreRun);
    }
    toggleSummary(open = !this.summary.classList.contains('is-open')) { this.summary.classList.toggle('is-open', open); this.querySelector('[data-toggle-summary]').setAttribute('aria-expanded', String(open)); }
    focusVariant(row) {
      this.toggleSummary(true); const slot = this.querySelector('[data-slot="' + row.piece.category + '"]');
      slot.scrollIntoView({ block: 'nearest', behavior: this.reduced ? 'instant' : 'smooth' });
      const input = slot.querySelector('[data-variant]:not(:disabled),select'); input?.focus({ preventScroll: true }); slot.classList.add('needs-choice');
    }
    async addToCart() {
      if (this.locked || this.pending.size || this.restoringRun === this.restoreRun || this.uncertain || this.lastAdded === this.signature()) return;
      this.cancelDrag(); const rows = Object.values(this.selected); if (!rows.length) return;
      const missing = rows.find(s => !s.variant || !s.variant.available);
      if (missing) { this.say(this.words.choose_for + ' ' + missing.piece.title, true); this.focusVariant(missing); return; }
      this.locked = true; this.setAttribute('aria-busy', 'true'); this.setAttribute('data-state', 'adding'); this.render(); this.say(this.words.checking);
      let submitted = false, confirmed = false, invalidRow = null;
      try {
        const fresh = await Promise.all(rows.map(async s => { const r = await fetch(s.piece.url + '.js', { headers: { Accept: 'application/json' } }); if (!r.ok) throw new Error(this.words.verify_error); return r.json(); }));
        let invalid = null, changed = false;
        fresh.forEach((p, i) => { const row = rows[i]; const current = p.variants.find(v => String(v.id) === String(row.variant.id)); changed ||= current && current.price !== row.variant.price; row.piece.variants = p.variants.map(v => ({ id: v.id, title: v.title, price: v.price, available: v.available })); if (!current?.available) { row.variant = null; invalid = row; } else row.variant = row.piece.variants.find(v => v.id === current.id); });
        if (invalid) { invalidRow = invalid; this.render(); throw new Error(this.words.stock_changed + ' ' + invalid.piece.title); }
        if (changed) throw new Error(this.words.price_changed);
        const sections = []; document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
        this.say(this.words.adding); submitted = true;
        const response = await fetch(this.dataset.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: rows.map(s => ({ id: s.variant.id, quantity: 1 })), sections: [...new Set(sections)].slice(0, 5), sections_url: location.pathname }) });
        const result = await response.json();
        if (!response.ok) { this.uncertain = true; document.dispatchEvent(new CustomEvent('cart:refresh')); throw new Error((typeof result.description === 'string' ? result.description : this.words.cart_error) + ' ' + this.words.review_cart); }
        confirmed = true; this.lastAdded = this.signature(); this.querySelector('[data-cart]').hidden = false; this.say(this.words.added); this.setAttribute('data-state', 'added'); this.toast(this.words.added_short);
        try {
          const r = await fetch(this.dataset.root + 'cart.js', { headers: { Accept: 'application/json' } }); if (!r.ok) throw Error(); const cart = await r.json(); cart.sections = result.sections || {};
          if (sections.length && sections.every(s => cart.sections[s])) document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
          else document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (_) { document.dispatchEvent(new CustomEvent('cart:refresh')); }
      } catch (error) {
        if (!confirmed) { if (submitted) { this.uncertain = true; this.querySelector('[data-cart]').hidden = false; } this.say(submitted && error.message === 'Failed to fetch' ? this.words.uncertain : error.message || this.words.cart_error, true); this.setAttribute('data-state', 'cart-error'); }
      } finally { this.locked = false; this.removeAttribute('aria-busy'); this.render(); if (invalidRow) this.focusVariant(invalidRow); }
    }
    setZoom(mode) { if (!this.stage) return; this.stage.dataset.zoom = mode; this.querySelectorAll('button[data-zoom]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.zoom === mode))); this.frameModel(); }
    updateThreeAuto() {
      const button = this.querySelector('[data-three-auto]'); if (!button) return;
      button.setAttribute('aria-pressed', String(this.threeAuto)); button.textContent = this.threeAuto ? this.threeWords.pause : this.threeWords.rotate;
    }
    syncThreeSelection() {
      this.viewer3d?.setSelection(this.selected);
      const rows = Object.values(this.selected || {}), unsupported = rows.filter(row => row.piece.handle !== 'elixir-spider-red-leather-jacket');
      const missing = rows.filter(row => !row.piece.render), note = this.querySelector('[data-missing-note]');
      if (note) { note.hidden = !missing.length; note.textContent = missing.length ? this.threeWords.missing + ' ' + missing.map(row => this.shortTitle(row.piece.title)).join(' · ') : ''; }
      const threeNote = this.querySelector('[data-three-note]');
      if (threeNote && this.viewer3d) threeNote.textContent = this.threeWords.prototype + (unsupported.length ? ' ' + this.threeWords.three_missing + ' ' + unsupported.map(row => this.shortTitle(row.piece.title)).join(' · ') : !rows.length ? ' ' + this.threeWords.three_empty : '');
    }
    async setDisplayMode(mode) {
      if (!['photo', '3d'].includes(mode)) return;
      this.cancelDrag(false); this.displayMode = mode; this.dataset.displayMode = mode;
      this.querySelectorAll('button[data-display-mode]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.displayMode === mode)));
      if (mode === 'photo') { this.viewer3d?.setAutoRotate(false); this.threeAuto = false; this.updateThreeAuto(); this.frameModel(); return; }
      if (this.viewer3d) { this.syncThreeSelection(); return; }
      const mount = this.mountVersion;
      this.querySelector('[data-three-note]').textContent = this.threeWords.loading;
      this.querySelectorAll('[data-three-tools] button').forEach(button => button.disabled = true);
      try {
        if (!this.threeMountPromise) this.threeMountPromise = (async () => {
          if (!window.ElixirOutfit3D?.mount) await new Promise((resolve, reject) => {
            const script = this.querySelector('[data-outfit3d-script]');
            if (!script) return reject(new Error('missing-3d-script'));
            const timer = setTimeout(() => finish(new Error('3d-script-timeout')), 20000);
            const loaded = () => finish(); const failed = () => finish(new Error('3d-script-load'));
            const finish = error => { clearTimeout(timer); script.removeEventListener('load', loaded); script.removeEventListener('error', failed); error ? reject(error) : resolve(); };
            script.addEventListener('load', loaded, { once:true }); script.addEventListener('error', failed, { once:true });
            if (window.ElixirOutfit3D?.mount) finish();
          });
          if (!window.ElixirOutfit3D?.mount) throw new Error('missing-3d-api');
          return window.ElixirOutfit3D.mount(this.threeContainer, { modelUrl:this.threeContainer.dataset.modelUrl });
        })();
        const viewer = await this.threeMountPromise;
        if (!this.active || mount !== this.mountVersion) { viewer?.dispose(); return; }
        if (!viewer || typeof viewer.setSelection !== 'function') throw new Error('invalid-3d-api');
        this.viewer3d = viewer; viewer.setSelection(this.selected);
        await viewer.readyPromise;
        if (!this.active || mount !== this.mountVersion) { viewer.dispose(); return; }
        this.syncThreeSelection();
        this.querySelectorAll('[data-three-tools] button').forEach(button => button.disabled = false);
      } catch (error) {
        this.threeMountPromise = null;
        if (!this.active || mount !== this.mountVersion) return;
        this.viewer3d?.dispose(); this.viewer3d = null;
        this.setDisplayMode('photo'); this.say(this.threeWords.error, true);
      }
    }
    frameModel() {
      if (!this.scene || !this.person || this.displayMode === '3d') return;
      const frame = this.scene.getBoundingClientRect(), mode = this.stage.dataset.zoom || 'full';
      const box = { full: [.19, .005, .80, .985], upper: [.21, .005, .79, .58], lower: [.20, .415, .80, .985] }[mode];
      if (!box || frame.width < 1 || frame.height < 1) return;
      const controls = this.querySelector('.eo3-controls')?.getBoundingClientRect().height || 48;
      const top = 36, bottom = controls + 18, h = Math.max(200, frame.height - top - bottom), w = Math.max(200, frame.width - 32);
      const maxPixels = Math.min(1, (this.querySelector('.eo3-model')?.naturalWidth || 1024) / 1024);
      const factor = Math.min(w / ((box[2] - box[0]) * 1024), h / ((box[3] - box[1]) * 1536), maxPixels);
      const width = 1024 * factor, height = 1536 * factor;
      this.person.style.width = width + 'px'; this.person.style.height = height + 'px';
      this.person.style.left = (frame.width / 2 - width * (box[0] + box[2]) / 2) + 'px';
      this.person.style.top = (top + (h - (box[3] - box[1]) * height) / 2 - box[1] * height) + 'px';
    }
    openDetail(id, trigger) {
      const p = this.pieces.get(id); if (!p?.photos?.length || !this.detail) return;
      this.cancelDrag(); this.detailPiece = p; this.detailTrigger = trigger; this.detailIndex = p.detailImage ? 0 : Math.min(Math.max(0, p.detailIndex || 0), p.photos.length - 1);
      this.detail.hidden = false; this.wardrobe.classList.add('has-detail');
      this.querySelector('[data-detail-name]').textContent = this.shortTitle(p.title); this.detailPhoto(0);
      this.querySelector('[data-close-detail]').focus({ preventScroll: true });
      if (matchMedia('(max-width: 999px)').matches) this.detail.scrollIntoView({ block: 'nearest', behavior: this.reduced ? 'instant' : 'smooth' });
    }
    closeDetail(focus = true) {
      if (!this.detail || this.detail.hidden) return;
      this.detail.hidden = true; this.wardrobe.classList.remove('has-detail'); this.detailPiece = null;
      if (focus && this.detailTrigger?.isConnected) this.detailTrigger.focus({ preventScroll: true });
    }
    detailPhoto(delta) {
      const p = this.detailPiece; if (!p?.photos?.length) return;
      this.detailIndex = (this.detailIndex + delta + p.photos.length) % p.photos.length;
      const photo = p.photos[this.detailIndex], img = this.querySelector('[data-detail-image]');
      this.querySelector('[data-detail-error]').hidden = true;
      img.onload = () => { this.querySelector('[data-detail-error]').hidden = true; };
      img.onerror = () => { this.querySelector('[data-detail-error]').hidden = false; };
      img.src = photo.src; img.alt = photo.alt || p.title;
      this.querySelector('[data-detail-count]').textContent = (this.detailIndex + 1) + ' / ' + p.photos.length;
      this.querySelector('[data-detail-prev]').disabled = p.photos.length < 2; this.querySelector('[data-detail-next]').disabled = p.photos.length < 2;
    }
    inspect(id, trigger) {
      const p = this.pieces.get(id); if (!p) return; this.cancelDrag(); this.gallery = p; this.galleryTrigger = trigger;
      this.querySelector('[data-gallery-title]').textContent = p.title; this.querySelector('[data-gallery-link]').href = p.url;
      const list = this.querySelector('[data-gallery-thumbs]'); list.replaceChildren();
      p.photos.forEach((photo, i) => { const b = this.button('eo3-gallery-thumb'); b.dataset.photo = i; b.setAttribute('aria-label', this.words.photo + ' ' + (i + 1)); const img = this.node('img'); img.src = photo.thumb; img.alt = ''; img.loading = 'lazy'; b.append(img); list.append(b); });
      this.showPhoto(this.detailPiece?.id === p.id ? this.detailIndex : 0); this.dialog.showModal();
    }
    showPhoto(index) { const photo = this.gallery.photos[index]; if (!photo) return; const img = this.querySelector('[data-gallery-image]'); img.src = photo.src; img.alt = photo.alt || this.gallery.title; this.querySelectorAll('[data-photo]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.photo) === index))); }
    readSaved(key) {
      const saved = JSON.parse(localStorage.getItem(key));
      if (saved?.version !== 3 || !Array.isArray(saved.items) || !saved.items.length || saved.items.length > 3) return null;
      if (saved.items.some(i => !i || typeof i.handle !== 'string' || (i.variant !== null && !Number.isSafeInteger(i.variant)))) return null;
      if (new Set(saved.items.map(i => i.handle)).size !== saved.items.length) return null;
      return saved;
    }
    checkSaved() {
      for (const [selector, key] of [['[data-restore]', this.storageKey], ['[data-restore-previous]', this.storageKey + ':previous']]) {
        let saved = null; try { saved = this.readSaved(key); } catch (_) {}
        this.querySelector(selector)?.toggleAttribute('hidden', !saved);
      }
    }
    save() {
      if (this.locked || this.pending.size || this.restoringRun === this.restoreRun || !Object.keys(this.selected).length) return;
      try {
        const value = JSON.stringify({ version: 3, items: Object.values(this.selected).map(s => ({ handle: s.piece.handle, variant: s.variant?.id || null })) });
        const previous = localStorage.getItem(this.storageKey), changed = previous && previous !== value;
        // Preserve the previous raw value even if it was produced by an older version.
        if (changed) localStorage.setItem(this.storageKey + ':previous', previous);
        localStorage.setItem(this.storageKey, value); this.checkSaved(); this.say(changed ? this.words.saved_previous : this.words.saved);
      }
      catch (_) { this.say(this.words.save_error, true); }
    }
    async restore(key = this.storageKey) {
      if (this.locked) return; this.cancelDrag();
      let run; const mount = this.mountVersion;
      try { const saved = this.readSaved(key); if (!saved) return; run = ++this.restoreRun; this.restoringRun = run; this.updateTotal(); let skipped = false;
        this.say(this.words.checking);
        const categories = new Set();
        const prepared = await Promise.all(saved.items.map(async item => {
          const p = [...this.pieces.values()].find(p => p.handle === item.handle);
          if (!p || categories.has(p.category)) { skipped = true; return null; } categories.add(p.category);
          try {
            const response = await fetch(p.url + '.js', { headers: { Accept: 'application/json' } });
            if (!response.ok) { skipped = true; return null; }
            const fresh = await response.json(); if (this.mountVersion !== mount || run !== this.restoreRun || !this.active) return null;
            const variants = fresh.variants.map(v => ({ id: v.id, title: v.title, price: v.price, available: v.available }));
            if (!variants.some(v => v.available)) { skipped = true; return null; }
            const variant = variants.find(v => String(v.id) === String(item.variant) && v.available);
            if (item.variant && !variant) skipped = true;
            const image = await this.imageFor(p);
            return { p, variants, variant, image };
          } catch (_) { skipped = true; return null; }
        }));
        if (this.mountVersion !== mount || run !== this.restoreRun || !this.active) return;
        const ready = prepared.filter(Boolean);
        // A failed restore keeps the current outfit. Commit only after resources are ready.
        if (ready.length) {
          this.closeDetail(false); this.selected = {};
          for (const cat of ['top', 'bottom', 'accessory']) { this.versions[cat] = (this.versions[cat] || 0) + 1; this.pending.delete(cat); this.querySelector('[data-layer="' + cat + '"]').replaceChildren(); }
          ready.forEach(({ p, variants, variant, image }) => { p.variants = variants; this.commit(p, image, variant?.id || null); });
          this.render();
        }
        this.say(skipped ? this.words.restore_partial : this.words.restored);
      } catch (_) { if (this.mountVersion === mount) this.say(this.words.save_error, true); }
      finally { if (this.mountVersion === mount && this.restoringRun === run) { this.restoringRun = null; this.updateTotal(); } }
    }
  }
  customElements.define('elixir-outfit', ElixirOutfit);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password-header"]) return;
  try {
    
if (!customElements.get('elixir-password-countdown')) {
  customElements.define('elixir-password-countdown', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.timer);
      const date = this.dataset.date.trim();
      const time = this.dataset.time.trim();
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^([01]\d|2[0-3]):[0-5]\d$/.test(time)) return;
      const [year, month, day] = date.split('-').map(Number);
      const [hour, minute] = time.split(':').map(Number);
      const wall = Date.UTC(year, month - 1, day, hour, minute);
      if (new Date(wall).toISOString().slice(0, 10) !== date) return;
      const formatter = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Madrid', year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit', hourCycle:'h23'});
      let target = wall;
      for (let i = 0; i < 3; i++) {
        const p = Object.fromEntries(formatter.formatToParts(new Date(target)).map(part => [part.type, part.value]));
        const represented = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
        target += wall - represented;
      }
      const tick = () => {
        const remaining = Math.max(0, Math.floor((target - Date.now()) / 1000));
        const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
        ['days', 'hours', 'minutes', 'seconds'].forEach((name, index) => {
          const node = this.querySelector('#' + name);
          if (node) node.textContent = String(values[index]).padStart(2, '0');
        });
        if (!remaining) clearInterval(this.timer);
      };
      this.timer = setInterval(tick, 1000);
      tick();
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
